var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoNetworks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:none;stroke:#BABABA;stroke-width:2.6682;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#CFCFCF;}\n\t.st3{fill:#D2D2D2;}\n\t.st4{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.6682;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.2,77.3c-22.3,0-45-0.9-66.2-6.8c-21.2-5.9-39.9-17-57-30c-11.2-8.5-21.3-15.2-35.8-14.1 c-14.2,0.7-27.7,6-38.7,15.1c-18.4,16-15.6,46-8.3,67C23.3,140.1,57,162,85.7,176.4c33.1,16.5,69.4,26.1,106,31.7 c32,4.9,73,8.4,100.7-12.5c25.5-19.2,32.4-63,26.2-92.6c-1.5-8.7-6.2-16.6-13.1-22.2c-17.9-13-44.5-4.3-64.6-3.9 C233.4,77.1,225.7,77.3,218.2,77.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.3,143.1v11.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.6,148.8H294"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.6,78v11.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.8,83.7h11.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.6,29.3c1.4,0,2.6-1.2,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6c-1.4,0-2.6,1.2-2.6,2.6 C155.9,28.1,157.1,29.3,158.6,29.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.1,18.4c1.4,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6c-1.4,0-2.6,1.2-2.6,2.6S59.6,18.4,61.1,18.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.8,259.8c54,0,97.8-2.7,97.8-6.1c0-3.4-43.8-6.1-97.8-6.1c-54,0-97.8,2.7-97.8,6.1 C77,257.1,120.8,259.8,174.8,259.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M134.6,84.7h-10.2V155h10.2V84.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.2,89.8l4.8,8.9l58.8-31.8L183,58L124.2,89.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M121.1,148.9h15.6c7.9,0,15.5,3.2,21.2,8.8c5.6,5.6,8.8,13.2,8.8,21.2v2.2H91.2v-2.2c0-7.9,3.2-15.5,8.8-21.2 C105.6,152,113.2,148.9,121.1,148.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.9,181.3H81"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M130.1,110.6c9.7,0,17.6-7.9,17.6-17.6s-7.9-17.6-17.6-17.6s-17.6,7.9-17.6,17.6S120.4,110.6,130.1,110.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M228.2,160.1c-0.5-0.2-3.9,0.2-4.3,0c-3.1-1.1-4.2,2.7-7,1.1c-18-9.3-32-24.8-39.4-43.7 c-7.3-18.9-7.5-39.8-0.5-58.8c7-19,20.7-34.8,38.6-44.4c17.9-9.6,38.6-12.3,58.3-7.6c3.4,0.8,6.7,1.8,9.9,3c0.6,0.2-0.9,3.5-0.3,3.7 L228.2,160.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M281.3,96.9c-12.9,34.4-31.9,60.6-47.3,67.4c-2.1,1-4.3,1.5-6.6,1.7c-1.7,0.1-3.4-0.1-5.1-0.7 c-1.3-0.5-2.5-1.2-3.5-2.1c-0.6-0.5-1.1-1-1.6-1.6c-10.7-12.2-8.9-48,5.3-86.5c14.1-37.8,35.8-65.8,51.8-68.7c1-0.2,2-0.3,3-0.3 c1.4,0,2.7,0.3,4,0.7c1.8,0.7,3.5,1.8,4.8,3.2c1.4,1.5,2.6,3.2,3.5,5.1C297,30.5,294.1,62.7,281.3,96.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.2,73.6l83.4,30.4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.8,113.2c6.4,0,11.6-5.2,11.6-11.6S309.2,90,302.8,90s-11.6,5.2-11.6,11.6S296.3,113.2,302.8,113.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.9,39.7c0,1.5-0.3,2.9-0.9,4.3c-0.6,1.4-1.4,2.6-2.4,3.6c-1,1-2.3,1.9-3.6,2.4c-1.4,0.6-2.8,0.8-4.3,0.8 H69.3c-2.1,0-4.2-0.8-5.7-2.3c-1.5-1.5-2.3-3.5-2.3-5.7c0-2.1,0.8-4.2,2.3-5.7c1.5-1.5,3.5-2.3,5.7-2.3c1.1,0,2.1,0.2,3.1,0.6 c-0.1-0.5-0.2-1-0.2-1.6c0-2.1,0.8-4.1,2.2-5.6c1.4-1.6,3.3-2.6,5.3-2.9s4.2,0.2,5.9,1.3c1.7,1.1,3,2.9,3.6,4.9c2-1.9,4.7-3,7.5-2.9 c1.5,0,2.9,0.3,4.3,0.8c1.4,0.6,2.6,1.4,3.6,2.4c1,1,1.9,2.3,2.4,3.6C107.6,36.8,107.9,38.2,107.9,39.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNetworks);
export default __webpack_public_path__ + "static/media/no-networks.5758abb3283d00d6788903a55a3bf30d.svg";
export { ForwardRef as ReactComponent };